import { FilterRegion } from "./FilterRegion"
import { FilterMarketFiltered } from "./FilterMarketFiltered"
import { FilterMarket } from "./FilterMarket"
import { FilterClient } from "./FilterClient"
import { FilterBrand } from "./FilterBrand"
import { FilterYear } from "./FilterYear"
import { FilterScenario } from "./FilterScenario"
import { ClientInfo, LookupDataType } from "../../types"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { Grid } from "@material-ui/core"
import { Dispatch, SetStateAction } from "react"

interface FiltersProps {
  lookups?: LookupDataType
  isViewGcf?: boolean
  showDetails: boolean
  client?: ClientInfo
  isLoadingClient: boolean
  setIsGcf: Dispatch<SetStateAction<boolean>>
  assignedBrand?: string
  assignedClients?: ClientInfo[]
}
export function Filters({
  lookups,
  isViewGcf,
  showDetails,
  client,
  isLoadingClient,
  assignedBrand,
  assignedClients,
  setIsGcf,
}: FiltersProps) {
  const { pathname, search, regionParam, brandParam, marketParam } =
    useRevenueParams()
  const commonProps = { pathname, search }
  return (
    <Grid
      container
      alignItems="center"
      style={{ gap: "16px", marginLeft: "auto", width: "auto" }}
    >
      <Grid item>
        <FilterRegion
          regions={lookups?.regions}
          filtered={lookups?.isMarketFiltered || lookups?.isRegionFiltered}
          regionCode={regionParam}
          {...commonProps}
        />
      </Grid>

      {lookups?.isMarketFiltered ? (
        <Grid item>
          <FilterMarketFiltered marketParam={marketParam} {...commonProps} />
        </Grid>
      ) : (
        <Grid item>
          <FilterMarket
            regionParam={regionParam}
            marketParam={marketParam}
            {...commonProps}
          />
        </Grid>
      )}
      <Grid item>
        <FilterClient
          regionCode={regionParam}
          client={client}
          assignedClients={assignedClients}
          isLoading={isLoadingClient}
          {...commonProps}
        />
      </Grid>
      <Grid item>
        <FilterBrand
          setIsGcf={setIsGcf}
          brands={!!assignedBrand ? [assignedBrand] : lookups?.brandFilters}
          regionDefault={lookups?.regionDefault || "All"}
          marketDefault={lookups?.regions?.[0].markets?.[0].name || "All"}
          isViewGcf={isViewGcf}
          showDetails={showDetails}
          brand={!!assignedBrand ? assignedBrand : brandParam}
          disabled={!!assignedBrand}
          {...commonProps}
        />
      </Grid>
      <Grid item>
        <FilterYear years={lookups?.globalFiltersYear} />
      </Grid>
      <Grid item>
        <FilterScenario />
      </Grid>
    </Grid>
  )
}
